export default class Animate {
    static addClass(el, c, delay, parallel) {
        const items = el instanceof Array ? el : [el];
        return Promise.all(items.map((el, i) => new Promise((resolve) => { setTimeout(() => { el.classList.add(c); resolve(); },  parallel ? delay : (i + 1) * delay); })));
    }

    static removeClass(el, c, delay, parallel) {
        const items = el instanceof Array ? el : [el];
        return Promise.all(items.map((el, i) => new Promise((resolve) => { setTimeout(() => { el.classList.remove(c); resolve(); }, parallel ? delay : (i + 1) * delay); })));
    }

    static scroll(el) {
        el.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }
}